
import { Options, Vue } from "vue-class-component";
import {
  formatByCountry,
  formatDate,
  resolveCountry,
} from "@/app/infrastructures/misc/Utils";
import PopupDepositDetail from "@/app/ui/views/cod-delivery-v2/components/popup-deposit-detail.vue";
import PreviewImagePod from "@/app/ui/views/shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";

import {
  TaskSetllementCourier,
  SttDetailSetorRiwayat,
  PhotosDetailSetorRiwayat,
  DetailDepositRiwayat
} from "@/domain/entities/CodReconcile";

@Options({
  components: { PreviewImagePod, PopupDepositDetail },
  props: {
    deposits: {
      type: Array as () => TaskSetllementCourier[],
      default: () => []
    },
    type: {
      type: String,
      default: 'uang'
    }
  }
})
export default class CardDeposit extends Vue {
  // props
  deposits!: TaskSetllementCourier[];

  // local state
  showPopup = false;
  isPreviewPhotos = false;
  previewPhotos: string[] = [];
  selectedDeposit: DetailDepositRiwayat | null = null;

  // preview image handlers
  onPreview(photos: Array<string | PhotosDetailSetorRiwayat>) {
    this.previewPhotos = photos
      .map((p: string | PhotosDetailSetorRiwayat) =>
        typeof p === "string"
          ? p
          : (p && (p as PhotosDetailSetorRiwayat).url) || ""
      )
      .filter((u) => !!u);
    this.isPreviewPhotos = true;
  }

  onClosePreview() {
    this.isPreviewPhotos = false;
  }

  // utils
  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  formatPriceRP(value: number) {
    return value ? formatByCountry(value, { type: "money", prefix: this.prefixCurrency }) : "";
  }

  // scroll controls
  scrollLeft() {
    const container = this.$refs.scrollContainer as HTMLElement | null;
    if (container) container.scrollBy({ left: -250, behavior: "smooth" });
  }

  scrollRight() {
    const container = this.$refs.scrollContainer as HTMLElement | null;
    if (container) container.scrollBy({ left: 250, behavior: "smooth" });
  }

  // open popup detail with typed dummy structure using entities
  openPopup(item: TaskSetllementCourier) {
    const photosEntities = (item.proofUrls || []).map((img: any) => {
      if (img instanceof PhotosDetailSetorRiwayat) return img;
      if (img && typeof img === "object" && "url" in img) {
        return new PhotosDetailSetorRiwayat({ url: (img as any).url || "" });
      }

      if (typeof img === "string") {
        return new PhotosDetailSetorRiwayat({ url: img });
      }

      return new PhotosDetailSetorRiwayat({ url: "" });
    });

    const sttEntities = (item.stt || []).map(
      (stt: any) =>
        new SttDetailSetorRiwayat({
          sttNo: stt.sttNo || '',
          lastStatus: stt.lastStatus || '',
          isReconciled: stt.isReconciled ?? true,
          totalAmount: stt.totalAmount || 0,
          totalPiece: stt.totalPiece || 0,
          codType: stt.codType || '',
        })
    );

    this.selectedDeposit = new DetailDepositRiwayat({
      createdAt: item.createdAt || '',
      totalAmount: item.totalAmount || 0,
      totalPackage: item.stt.length || 0,
      totalPiece: item.stt.length || 0,
      photos: photosEntities,
      stt: sttEntities,
      recipientName: item.personName,
      recipientLocation: item.location,
      paymentMethod: item.paymentMethod
    });

    this.showPopup = true;
  }

  formatDateToString(dateString: string): string {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: 'short', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Jakarta'
    };

    const formattedDate = date.toLocaleDateString('id-ID', options as any);
    return `${formattedDate} WIB`;
  }

}
